import React, { useState } from 'react'

import { ExporterProps } from 'components/deckPage/modals/Export/types'

import ToastService from 'services/toast.service'

import PhatButton from 'components/formElements/PhatButton'
import Checkbox from 'components/formElements/Checkbox'

import { generateEdhrecText } from './helper'

import genericStyles from 'components/deckPage/modals/Export/generic.module.scss'

const EDHREC = ({ selectedCards, categoryMap, fileName = 'EDHREC export' }: ExporterProps) => {
  const [useCategoryNames, setUseCategoryNames] = useState(false)

  const fileContents = generateEdhrecText(selectedCards, categoryMap, fileName, useCategoryNames)

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(fileContents)

      ToastService.create('Copied to clipboard', 'Deck Export', 'success')
    } catch {
      ToastService.create('Unable to copy to clipboard', 'Deck Export')
    }
  }

  return (
    <div>
      <Checkbox
        checked={useCategoryNames}
        onChange={() => setUseCategoryNames(!useCategoryNames)}
        label="Group cards by primary category"
      />

      <div className={genericStyles.controls}>
        <PhatButton icon="copy outline" onClick={handleCopy} color="blue">
          Copy
        </PhatButton>
      </div>
    </div>
  )
}

export default EDHREC
